export default "__VITE_ASSET__CGHx$7QX__"